import type { IconGlyph } from '../icon';

/**
 * Tractie `menu` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/menu.jsx`.
 */
export const iconMenu: IconGlyph = {
  name: 'menu',
  path: 'M3.5 6h17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-17c-.28 0-.5.22-.5.5s.22.5.5.5m17 5h-17c-.28 0-.5.22-.5.5s.22.5.5.5h17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5m-8 6h-9c-.28 0-.5.22-.5.5s.22.5.5.5h9c.28 0 .5-.22.5-.5s-.22-.5-.5-.5',
};
